const eventBus = {};

eventBus.install = function (Vue) {
  Vue.prototype.$bus = new Vue();
};

export default eventBus;



// WEBPACK FOOTER //
// ./src/common/plugins/event-bus.js